function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var module;
// LICENSE_CODE ZON
'use strict'; /*jslint react:true, es6:true, node:true*/
(function () {
  var is_node = typeof module == 'object' && module.exports;
  if (is_node) ;else ;
  define([], () => {
    var E = {};
    E.marked_items = [{
      category: ['tv', 'game_platforms'],
      items: ['firetv', 'lg']
    }, {
      category: ['more'],
      items: ['shoopit']
    }];
    E.buttons_sets = {
      browsers: [{
        name: 'chrome',
        href: 'https://chromewebstore.google.com/detail/' + 'hola-vpn-the-website-unbl/gkojfkhlekighikafcpjkiklfbnlmeio',
        title: 'Chrome'
      }, {
        name: 'edge',
        title: 'Microsoft Edge',
        href: 'https://microsoftedge.microsoft.com/addons/detail/' + 'eibinhpjpbkmjeohlclnebmkhdfehpbf',
        rel: 'windows'
      }, {
        name: 'opera',
        title: 'Opera',
        href: 'https://addons.opera.com/en/extensions/details/' + 'hola-better-internet/'
      }],
      platforms: [{
        name: 'android',
        href: 'https://play.google.com/store/apps/details?' + 'id=org.hola.play',
        title: 'Android'
      }, {
        name: 'ios',
        href: 'https://apps.apple.com/us/app/hola-vpn/id1553473179?' + 'platform=iphone',
        title: 'iOS'
      }, {
        name: 'huawei',
        href: 'https://appgallery.huawei.com/#/app/C102688195',
        title: 'Huawei'
      },
      // XXX dmitriikup: URG request from noav to remove all Samsung
      // {name: 'samsung', href: 'https://galaxystore.samsung.com/detail/org.hola.samsung',
      //     title: 'Samsung',},
      {
        name: 'windows',
        href: '/download',
        title: 'Windows'
      }, {
        name: 'mac_beta',
        href: '/download/mac',
        title: 'Mac'
      }],
      game_platforms: [{
        name: 'xbox',
        href: '/plus_setup?platform=console&type=xbox_one',
        title: 'Xbox',
        tooltip_pos: 'bottom'
      }, {
        name: 'playstation',
        href: '/plus_setup?platform=console&type=ps4',
        title: 'Playstation',
        tooltip_pos: 'bottom'
      }, {
        name: 'console',
        href: '/plus_setup?platform=console',
        title: 'Consoles',
        tooltip_pos: 'bottom'
      }, {
        name: 'router',
        href: '/plus_setup?platform=router',
        title: 'Routers',
        tooltip_pos: 'bottom'
      }, {
        name: 'appletv',
        href: 'https://apps.apple.com/us/app/hola-vpn/id1553473179?' + 'platform=appleTV',
        title: 'Apple TV',
        tooltip_pos: 'bottom'
      }, {
        name: 'smarttv',
        href: 'https://support.hola.org/en/collections/10103755-smart-TV',
        title: 'Smart TV',
        tooltip_pos: 'bottom'
      }],
      premium_setup: [{
        name: 'windows',
        title: 'Windows',
        href: '/plus_setup?platform=windows',
        versions_text: 'Please select your OS version',
        versions: [{
          name: '7',
          title: 'Windows 7'
        }, {
          name: '8',
          title: 'Windows 8'
        }, {
          name: '10',
          title: 'Windows 10'
        }, {
          name: '11',
          title: 'Windows 11'
        }]
      }, {
        name: 'mac',
        title: 'MacOS',
        href: '/plus_setup?platform=mac'
      }, {
        name: 'android',
        title: 'Android',
        href: '/plus_setup?platform=android',
        versions_text: 'Please specify the device',
        versions: [{
          name: 'android',
          title: 'Android'
        },
        // XXX dmitriikup: URG request from noav to remove
        // all Samsung
        // {name: 'samsung', title: 'Samsung'},
        {
          name: 'huawei',
          title: 'Huawei'
        }]
      }, {
        name: 'ios',
        title: 'iPhone, iPad and Apple TV',
        href: '/plus_setup?platform=ios'
      }, {
        name: 'smarttv',
        title: 'Smart TV',
        href: '/plus_setup?platform=smarttv',
        versions_text: 'Please select your TV manufacturer',
        versions: [{
          name: 'lg',
          title: 'LG'
        }, {
          name: 'panasonic',
          title: 'Panasonic'
        }, {
          name: 'philips',
          title: 'Philips'
        },
        // XXX dmitriikup: URG request from noav to remove
        // all Samsung
        // {name: 'samsung', title: 'Samsung'},
        {
          name: 'sony',
          title: 'Sony'
        }, {
          name: 'toshiba',
          title: 'Toshiba'
        }, {
          name: 'appletv',
          title: 'Apple TV'
        }]
      }, {
        name: 'console',
        title: 'Consoles',
        href: '/plus_setup?platform=console',
        versions_text: 'Please select your device model',
        versions: [{
          name: 'ps4',
          title: 'Playstation 4'
        }, {
          name: 'ps_vita',
          title: 'Nintendo Switch'
        }, {
          name: 'xbox_one',
          title: 'Xbox One'
        }],
        tooltip_pos: 'bottom'
      }, {
        name: 'router',
        title: 'Routers',
        href: '/plus_setup?platform=router',
        versions_text: 'Please select your device model',
        versions: [{
          name: 'keeneticu',
          title: 'Keenetic Ultra'
        }],
        tooltip_pos: 'bottom'
      }, {
        name: 'ie',
        title: 'Internet Explorer',
        href: '/plus_setup?platform=ie',
        tooltip_pos: 'bottom'
      }, {
        name: 'edge',
        title: 'Edge',
        href: '/plus_setup?platform=edge',
        install_href: 'https://www.microsoft.com/en-us/edge',
        store: 'https://microsoftedge.microsoft.com/addons/detail/' + 'eibinhpjpbkmjeohlclnebmkhdfehpbf',
        tooltip_pos: 'bottom'
      },
      /* {name: 'firefox', title: 'Firefox',
          href: '/plus_setup?platform=firefox',
          install_href: 'https://www.mozilla.org/firefox/',
          store: 'https://addons.mozilla.org/en-US/firefox/addon/' +
              'hola-vpn-free-secure-proxy/',
          tooltip_pos: 'bottom'}, */
      {
        name: 'chrome',
        title: 'Chrome',
        href: '/plus_setup?platform=chrome',
        install_href: 'https://www.google.com/chrome/',
        store: 'https://chromewebstore.google.com/detail/' + 'hola-vpn-the-website-unbl/' + 'gkojfkhlekighikafcpjkiklfbnlmeio',
        tooltip_pos: 'bottom'
      }, {
        name: 'opera',
        title: 'Opera',
        href: '/plus_setup?platform=opera',
        install_href: 'https://www.opera.com/',
        store: 'https://addons.opera.com/en-gb/extensions/details/' + 'hola-better-internet/',
        tooltip_pos: 'bottom'
      }]
    };
    E.hola_apps = {
      browsers: [{
        name: 'chrome',
        href: 'https://chromewebstore.google.com/detail/' + 'hola-vpn-the-website-unbl/gkojfkhlekighikafcpjkiklfbnlmeio',
        title: 'Chrome'
      }, {
        name: 'edge',
        title: 'Microsoft Edge',
        href: 'https://microsoftedge.microsoft.com/addons/detail/' + 'eibinhpjpbkmjeohlclnebmkhdfehpbf'
      }, {
        name: 'opera',
        title: 'Opera',
        href: 'https://addons.opera.com/en/extensions/details/' + 'hola-better-internet/'
      }],
      mobile: [{
        name: 'android',
        href: 'https://play.google.com/store/apps/details?' + 'id=org.hola.play',
        title: 'Android'
      }, {
        name: 'ios',
        href: 'https://apps.apple.com/us/app/hola-vpn/id1553473179?' + 'platform=iphone',
        title: 'iOS'
      }, {
        name: 'huawei',
        href: 'https://appgallery.huawei.com/#/app/C102688195',
        title: 'Huawei'
      }
      // XXX dmitriikup: URG request from noav to remove all Samsung
      // {name: 'samsung', href: 'https://galaxystore.samsung.com/detail/org.hola.samsung',
      //     title: 'Samsung',},
      ],
      desktop: [{
        name: 'windows',
        title: 'Windows'
      }, {
        name: 'mac_beta',
        title: 'Mac'
      }],
      tv: [{
        name: 'firetv',
        href: 'https://www.amazon.com/Hola-Free-VPN-Proxy-Unblocker/dp/' + 'B08XBVQ81K/ref=cm_cr_arp_d_product_top?ie=UTF8',
        title: 'Fire TV'
      }, {
        name: 'lg',
        href: 'https://us.lgappstv.com/main/tvapp/detail?appId=1094740&' + 'catCode1=003&moreYn=N&cateYn=Y&orderType=0&' + 'headerName=Entertainment',
        title: 'LG'
      }, {
        name: 'appletv',
        href: 'https://apps.apple.com/us/app/hola-vpn/id1553473179?platform=appleTV',
        title: 'Apple TV'
      }, {
        name: 'smarttv',
        href: 'https://support.hola.org/en/collections/10103755-smart-tv',
        title: 'Smart TV',
        button_text: 'Setup guide'
      }],
      other: [{
        name: 'xbox',
        href: '/plus_setup?platform=console&type=xbox_one',
        title: 'Xbox',
        button_text: 'Setup guide'
      }, {
        name: 'playstation',
        href: '/plus_setup?platform=console&type=ps4',
        title: 'Playstation',
        button_text: 'Setup guide'
      }, {
        name: 'router',
        href: '/plus_setup?platform=router',
        title: 'Routers',
        button_text: 'Setup guide'
      }],
      more: [{
        name: 'browser',
        href: '/browser',
        title: 'Hola Browser'
      }, {
        name: 'luminati',
        href: 'https://brightdata.com/?affiliate=ref_590ad97180f5c1144ce118c8',
        title: 'Proxy for Business'
      }, {
        name: 'shoopit',
        href: 'https://shoopit.com',
        title: 'Shoopit'
      }]
    };
    function def_props(collection, name, props) {
      var index = -1;
      collection.forEach((item, i) => {
        if (item.name == name) index = i;
      });
      if (index >= 0) {
        Object.keys(props).forEach(pname => {
          Object.defineProperty(collection[index], pname, props[pname]);
        });
      }
    }
    E.store_links = {
      firefox: 'https://addons.mozilla.org/en-US/firefox/addon/' + 'hola-free-vpn-proxy-unblocker/',
      androidtv: 'https://play.google.com/store/apps/details?id=org.hola',
      'brightvpn-android': 'https://brightdata.com/static/BrightVPN-android-latest.apk',
      'brightvpn-lg': 'https://il.lgappstv.com/main/tvapp/detail?appId=1150014',
      'brightvpn-chrome': 'https://chromewebstore.google.com/detail/' + 'bright-vpn-secure-private/fbffombkfihfokifmkihbddiafipndnb',
      'brightvpn-edge': 'https://microsoftedge.microsoft.com/addons/detail/' + 'bright-vpn-secure-priv/elbjgikfbbdgjgbhneoabmkgbpmdfmkg',
      'brightvpn-firefox': 'https://addons.mozilla.org/en-GB/firefox/addon/bright-vpn/',
      'brightvpn-opera': 'https://addons.opera.com/en/extensions/details/' + 'bright-vpn-secure-private-and-free-vpn/'
    };
    for (var _i = 0, _arr = [E.buttons_sets, E.hola_apps]; _i < _arr.length; _i++) {
      var groups = _arr[_i];
      for (var _i2 = 0, _Object$values = Object.values(groups); _i2 < _Object$values.length; _i2++) {
        var items = _Object$values[_i2];
        var _iterator = _createForOfIteratorHelper(items),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var item = _step.value;
            if (!/^https:\/\/(play\.google\.com|apps\.apple\.com|appgallery\.huawei\.com|chromewebstore\.google\.com|microsoftedge\.microsoft\.com|addons\.opera\.com|www\.amazon\.com|us\.lgappstv\.com)\//.test(item.href || '')) continue;
            E.store_links[item.name] = item.href;
            item.href = '/download/store/' + item.name;
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    }
    E.is_download_country_blocked = country => ['CU', 'IN', 'IQ', 'IR', 'KP', 'LB', 'PS', 'SD', 'SY', 'RU', 'BY'].includes((country || '').toUpperCase());
    E.get_store_download_link = link => {
      var entry = Object.entries(E.store_links).find(([, target]) => target == link);
      return entry ? 'https://hola.org/download/store/' + entry[0] : link;
    };
    E.def_props = def_props;
    return E;
  });
})();